
export enum BusinessMetricCd {
	LOAD_FACTOR = 'LoadFactor'}

